"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSpinnerIconInside = exports.StyledSpinnerIconOutside = exports.StyledSpinnerIcon = exports.StyledSpinner = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledSpinner = styled_components_1.default.div `
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    min-width: ${({ size }) => `${size}px`};
    min-height: ${({ size }) => `${size}px`};
    overflow: hidden;

    ${({ invert, size, bgColor, theme }) => invert &&
    (0, styled_components_1.css) `
            box-sizing: border-box;
            padding: ${size / 10}px;
            position: relative;

            :before {
                content: '';
                position: absolute;

                top: 0;
                left: 0;
                right: 0;
                bottom: 0;

                border-radius: 50%;
                background-color: ${bgColor || theme.darkActiveColor};
            }
        `}
`;
const rotate = (0, styled_components_1.keyframes) `
    100% {
        transform: rotate(360deg);
    }
`;
exports.StyledSpinnerIcon = styled_components_1.default.svg `
    width: 100%;
    height: 100%;
    display: block;
    animation: ${rotate} ${({ isIE }) => (isIE ? '1s' : '2s')} linear infinite;
`;
const outsideAnimation = (r) => (0, styled_components_1.keyframes) `
    0% {
        stroke-dasharray: ${Math.floor(2 * Math.PI * r) / 4}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(-90deg);
    }

    25%{
        stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 3}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(-90deg);
    }

    50% {
        stroke-dasharray: ${Math.floor(2 * Math.PI * r) / 4}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(90deg);
    }

    75% {
        stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 3}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(90deg);
    }

    100% {
        stroke-dasharray: ${Math.floor(2 * Math.PI * r) / 4}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(270deg);
    }
`;
exports.StyledSpinnerIconOutside = styled_components_1.default.circle `
    stroke: ${({ color, theme }) => color || theme.colorProgressIndicator};
    stroke-width: 10;
    fill: none;
    transform-origin: 50% 50%;

    animation: ${({ r }) => (0, styled_components_1.css) `
            ${outsideAnimation(r)} 1.5s linear infinite
        `};

    ${({ isIE, r }) => isIE &&
    (0, styled_components_1.css) `
            stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 1.7},
                ${Math.floor(2 * Math.PI * r)};
        `}
`;
const insideAnimation = (r) => (0, styled_components_1.keyframes) `
    0% {
        stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 3}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(-90deg);
    }

    25% {
        stroke-dasharray: ${Math.floor(2 * Math.PI * r) / 4}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(90deg);
    }

    50% {
        stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 3}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(90deg);
    }

    75% {
        stroke-dasharray: ${Math.floor(2 * Math.PI * r) / 4}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(270deg);
    }

    100% {
        stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 3}, ${Math.floor(2 * Math.PI * r)};
        transform: rotate(270deg);
    }
`;
exports.StyledSpinnerIconInside = styled_components_1.default.circle `
    stroke: ${({ color, theme }) => color || theme.colorProgressIndicator};
    stroke-width: 5;
    fill: none;
    transform-origin: 50% 50%;

    animation: ${({ r }) => (0, styled_components_1.css) `
            ${insideAnimation(r)} 1.5s linear infinite
        `};

    ${({ isIE, r }) => isIE &&
    (0, styled_components_1.css) `
            stroke-dasharray: ${(Math.floor(2 * Math.PI * r) / 4) * 2.6},
                ${Math.floor(2 * Math.PI * r)};
        `}
`;
//# sourceMappingURL=Spinner.styles.js.map